export default __webpack_public_path__ + "static/media/case_study_card.4ececf58.svg";